/*
 * Copyright (c) 2024. Bolmate B.V.
 */

import {ResponseData, showDialog} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import React, {ForwardedRef, forwardRef, useImperativeHandle, useState} from 'react';
import {ActivateHandle, Churn, DataSplitMethod} from "../../../util/interfaces";
import {getChurn} from "../../../util/requestSender";
import {ISO_DATE_FORMAT} from "../../../util/constants";
import PlatformChurn from "./platformChurn";

function PlatformChurnController(props: {}, ref: ForwardedRef<ActivateHandle>) {
    const [data, setData] = useState<Array<Churn>>([]);
    const [fromDate, setFromDate] = useState<IDate | null>(null);
    const [toDate, setToDate] = useState<IDate | null>(null);
    const [splitMethod, setSplitMethod] = useState<DataSplitMethod>(DataSplitMethod.MONTH);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);

    function onActivate() {
        setActive(true);
        loadData();
    }

    function onClose() {
        setActive(false);
        setData([]);
        setFromDate(null);
        setToDate(null);
        setSplitMethod(DataSplitMethod.MONTH);
        setLoading(false);
    }

    function onChangeFromDate(value: IDate | null) {
        setFromDate(value);
    }

    function onChangeToDate(value: IDate | null) {
        setToDate(value);
    }

    function onChangeSplitMethod(value: DataSplitMethod) {
        setSplitMethod(value);
    }

    function loadData() {
        setLoading(true);
        getChurn({
            data: {
                from_date: fromDate?.format(ISO_DATE_FORMAT) ?? null,
                to_date: toDate?.format(ISO_DATE_FORMAT) ?? null,
                split_method: splitMethod,
            }, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) setData(data.churn);
                else
                    showDialog('Het bepalen van de churn is niet gelukt.', 'Churn bepalen mislukt');
            }
        })
    }

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return (
        <PlatformChurn onClose={onClose} onSubmit={loadData} onChangeFromDate={onChangeFromDate}
                       onChangeToDate={onChangeToDate} onChangeSplitMethod={onChangeSplitMethod} data={data}
                       fromDate={fromDate} toDate={toDate} splitMethod={splitMethod} loading={loading} active={active}/>
    )
}

export default forwardRef<ActivateHandle, {}>(PlatformChurnController);